import { InMemoryCache, Reference, StoreObject } from '@apollo/client'
import { user } from '@data/reactive-variables/profile'

import { hubHandler } from '../../auth/utils/hub-handler'

export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        paginatedDeliveries: {
          merge(_, incoming) {
            return incoming
          },
        },
        user: {
          read() {
            return user()
          },
        },
        hubSelected: {
          read() {
            return hubHandler().getHubSelectedFromApollo()
          },
        },
        movementsForPickingPaginated: {
          keyArgs: [
            'originHubId',
            'hubDestinationId',
            'referenceId',
            'orderId',
            'deliveryStatuses',
          ],
          merge(existing = { movements: [] }, incoming, { readField }) {
            const hasDeliveryReference = incoming.movements.some(
              (movement: Reference | StoreObject | undefined) => {
                const reference = readField(
                  'reference',
                  movement
                ) as Readonly<Reference>
                return (
                  reference &&
                  readField('referenceType', reference) === 'delivery'
                )
              }
            )

            if (hasDeliveryReference) {
              return incoming
            }

            const mergedMovements = [
              ...existing.movements,
              ...incoming.movements,
            ]

            const uniqueMovements = Array.from(
              new Map(
                mergedMovements.map((movement) => {
                  const movementId = readField('id', movement)
                  return [movementId, movement]
                })
              ).values()
            )

            return {
              ...incoming,
              movements: uniqueMovements,
            }
          },
        },
        movementsForCheckingPaginated: {
          keyArgs: ['originHubId', 'hubDestinationId', 'referenceId', 'status'],
          merge(existing = { checkings: [] }, incoming, { readField }) {
            const mergedCheckings = [
              ...existing.checkings,
              ...incoming.checkings,
            ]

            const uniqueMovements = Array.from(
              new Map(
                mergedCheckings.map((movement) => {
                  const checkingId = readField('id', movement)
                  return [checkingId, movement]
                })
              ).values()
            )

            return {
              ...incoming,
              checkings: uniqueMovements,
            }
          },
        },
        movementsForPicking: {
          keyArgs: ['originHubId'],
          merge(existing = [], incoming, { readField }) {
            const merged = [...existing, ...incoming]
            return Array.from(
              new Map(merged.map((p) => [readField('id', p), p])).values()
            )
          },
        },
      },
    },
    Hub: {
      keyFields: ['id'],
    },
    Picking: {
      keyFields: ['id'],
    },
    PickingItem: {
      keyFields: ['id'],
    },
    PickingMovement: {
      keyFields: ['id'],
    },
    Checking: {
      keyFields: ['id'],
    },
    CheckingItem: {
      keyFields: ['id'],
    },
  },
})
